module.exports = __webpack_public_path__ + "d7ae84c0142af6502343de494e326942.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-cleats.png
// module id = 2538
// module chunks = 0